import React, { useEffect, useState, useRef, useContext } from "react";
import * as S from "./HearingTestStyles";
import { Button } from "reactstrap";
import Results from "../Result/Results";
import { fetchAudioData, fetchAudioImagesData } from "./HearingTestAPI";
import T from "./data";
import { AppContext } from "../../AppContext";
import ImageButtons from "./components/ImageButtons/ImageButtons";
import NumberButtons from "./components/NumberButtons/NumberButtons";
import StartButtons from "./components/StartButtons/StartButtons";
import Input from "./components/Input/Input";

const maxVolume = 2;
const minVolume = -18;
const minVolumeImageTest = -12;

let player;
let imagesCombinations;
let correctAnswerCombination;

const setPlayer = (data) => {
  player.crossOrigin = "anonymous";
  player.volume = data.volume;
  if (data.listeningDevice === "headphones") {
    const audioContext = new AudioContext();
    const gainNode = audioContext.createGain();
    const track = audioContext.createMediaElementSource(player);
    const pannerOptions = { pan: -1 };
    const panner = new StereoPannerNode(audioContext, pannerOptions);
    track.connect(gainNode).connect(panner).connect(audioContext.destination);

    const switchEarsBtn = document.getElementById("switchEarsBtn");
    switchEarsBtn.addEventListener("click", () => {
      panner.pan.value = 1;
    });
  }
};

const setNumberCombination = (currentCombination) => {
  let randomNumberCombination =
    currentCombination[Math.floor(Math.random() * currentCombination.length)];

  while (randomNumberCombination === correctAnswerCombination) {
    //To avoid the same combination twice in a row
    randomNumberCombination =
      currentCombination[Math.floor(Math.random() * currentCombination.length)];
  }
  return randomNumberCombination;
};

const HearingTest = (props) => {
  const { data } = useContext(AppContext);

  const audioElement = useRef(null);

  const [inputValue, setInputValue] = useState("");
  const [showNextButton, setShowNextButton] = useState(false);
  const [showStartButton, setShowStartButton] = useState(true);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [numbersVolume, setNumbersVolume] = useState(null);

  const [displayResult, setDisplayResult] = useState(false);
  const [leftEarResult, setLeftEarResult] = useState(null);

  const [thresHoldAttempt, setThresHoldAttempt] = useState([]);
  const [hasAnsweredFalse, setHasAnsweredFalse] = useState(false);
  const [hasAnsweredCorrectly, setHasAnsweredCorrectly] = useState(false);
  const [prevMaxVolumeAnswerFalse, setPrevMaxVolumeAnswerFalse] = useState(
    false
  );
  const [prevMinVolumeAnswerCorrect, setPrevMinVolumeAnswerCorrect] = useState(
    false
  );

  const [currentUrl, setcurrentUrl] = useState("");

  const [combinations, setCombinations] = useState([]);

  //TODO: lisada enteriga lisamine jne
  useEffect(() => {
    player = document.getElementById("player");

    if (loading) {
      if (!data.isImageTest) {
        fetchAudioData().then((result) => {
          setCombinations(result);
          if (!result) {
            console.log("Error loading audio....");
            setLoading(true);
          } else {
            setLoading(false);
          }
        });
      } else {
        fetchAudioImagesData().then((result) => {
          // combinations = result;
          console.log(result);
          setCombinations(result);
          setLoading(false);
        });

        // let res = fetchAudioImagesData();
        // combinations = fetchAudioImagesData();
        // setCombinations(fetchAudioImagesData());
        // setLoading(false);
      }
    } else {
      // console.log("All combinations: ", combinations);

      // Add player settings
      setPlayer(data);

      // Starting volume depending on client age
      let startingVolume = -2;
      if (data.age > 50) startingVolume = 0;
      setNumbersVolume(startingVolume);

      generateCombination(startingVolume);
    }
  }, [loading]);

  const generateCombination = (volume) => {
    const shuffleArray = (array) => {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    };

    // Make (correct answer) random combination

    correctAnswerCombination = setNumberCombination(combinations);
    console.log("Current correct combination: ", correctAnswerCombination);

    if (data.isImageTest) {
      if (combinations.length > 0) {
        let shuffled = shuffleArray(combinations).slice(0, 9);
        if (shuffled.includes("roos") && shuffled.includes("ois")) {
          shuffled = shuffleArray(combinations).slice(0, 9);
        }
        if (shuffled.includes("roos") && shuffled.includes("ois")) {
          shuffled = shuffleArray(combinations).slice(0, 9);
        }

        if (!shuffled.includes(correctAnswerCombination)) {
          shuffled = shuffled.slice(0, 8);
          shuffled.push(correctAnswerCombination);
          shuffled = shuffleArray(shuffled);
        }
        imagesCombinations = shuffled;
      }
    }

    // Check where (what url) to take audio src data
    // let CORS = "https://cors-anywhere.herokuapp.com/";
    let baseUrl = "http://kuulmistest.tlu.ee/numberCombinations/";
    if (data.isImageTest)
      baseUrl = "http://kuulmistest.tlu.ee/imageCombinations/";

    if (volume > 0) volume = "+" + volume;

    let url = `${baseUrl}${volume}/${volume}_${correctAnswerCombination}${data.isImageTest ? ".wav" : ".mp3"}`;
    // let url = `${CORS + baseUrl}${volume}/${volume}_${correctAnswerCombination}${data.isImageTest ? ".wav" : ".mp3"}`;

    setcurrentUrl(url);
    // console.log("Generated track URL: ", url);
    // Todo: if image audio ok then remove if
    // if (!data.isImageTest) player.src = url;
    player.src = url;
  };

  const onStartBtnClick = () => {
    setShowStartButton(false);
    player.play();
  };

  const onRemoveNumbersBtnClick = () => {
    setInputValue("");
    setShowNextButton(false);
  };

  const onPlayNextBtnClick = () => {
    const switchEars = () => {
      // For resetting values
      onRemoveNumbersBtnClick();

      let numbersVolume = -2;
      if (data.age > 50) numbersVolume = 0;
      setNumbersVolume(numbersVolume);

      setNumberCombination(numbersVolume);

      setPrevMaxVolumeAnswerFalse(false);
      setPrevMinVolumeAnswerCorrect(false);
      setHasAnsweredFalse(false);
      setHasAnsweredCorrectly(false);
      setNumbersVolume(numbersVolume);
      setThresHoldAttempt([]);

      // Click to change pan for another ear
      const switchEarsBtn = document.getElementById("switchEarsBtn");
      switchEarsBtn.click();

      generateCombination(numbersVolume);
      player.play();
    };

    const addToThresholdAttempt = (userGuess) => {
      console.log(thresHoldAttempt);
      let arr = [userGuess, ...thresHoldAttempt];
      // let arrA = arr.push(userGuess);
      setThresHoldAttempt(arr);
    };

    const saveResults = (volumeLevel) => {
      if (data.listeningDevice === "headphones") {
        if (leftEarResult === null) {
          setLeftEarResult(volumeLevel);
          switchEars();
        } else {
          console.log("Left ear: " + leftEarResult);
          console.log("Right ear: " + volumeLevel);
          setResult(volumeLevel);
          displayResults();
        }
      } else {
        console.log("Result: " + volumeLevel);
        setResult(volumeLevel);
        displayResults();
      }
    };

    let newVolume;

    if (inputValue === correctAnswerCombination) {
      if (thresHoldAttempt.length !== 0) {
        saveResults(numbersVolume);
        return;
      } else if (hasAnsweredFalse && hasAnsweredCorrectly) {
        // console.log("VALUE last minus: ", thresHoldAttempt);
        addToThresholdAttempt(1);
        newVolume = numbersVolume;
      } else {
        if (
          data.isImageTest
            ? numbersVolume === minVolumeImageTest
            : numbersVolume === minVolume
        ) {
          // if (numbersVolume === minVolume) {
          if (prevMinVolumeAnswerCorrect) {
            saveResults(numbersVolume);
            return;
          } else {
            setPrevMinVolumeAnswerCorrect(true);
            newVolume = numbersVolume;
          }
        } else {
          newVolume = numbersVolume - 2;
          setNumbersVolume(newVolume);
          setPrevMaxVolumeAnswerFalse(false);
          setHasAnsweredCorrectly(true);
        }
      }
    } else {
      if (hasAnsweredCorrectly) {
        setHasAnsweredFalse(true);
      }

      if (thresHoldAttempt.length !== 0) {
        if (thresHoldAttempt[1] === 0) {
          if (numbersVolume === maxVolume) {
            saveResults(numbersVolume);
            return;
          } else {
            newVolume = numbersVolume + 2;
            setThresHoldAttempt([]);
            setNumbersVolume(newVolume);
          }
        } else {
          // console.log("VALUE 00000: ", thresHoldAttempt);
          addToThresholdAttempt(0);
          newVolume = numbersVolume;
        }
      } else {
        if (numbersVolume === maxVolume) {
          if (hasAnsweredCorrectly) {
            saveResults(numbersVolume);
            return;
          } else {
            if (prevMaxVolumeAnswerFalse) {
              saveResults(numbersVolume);
              return;
            } else {
              setPrevMaxVolumeAnswerFalse(true);
              newVolume = numbersVolume;
            }
          }
        } else {
          newVolume = numbersVolume + 2;
          setNumbersVolume(newVolume);
          // setPrevMaxVolumeAnswerFalse(false)
          setPrevMinVolumeAnswerCorrect(false);
        }
      }
    }

    onRemoveNumbersBtnClick();
    generateCombination(newVolume);
    player.play();
  };

  const onSaveNumberBtnClick = (value) => {
    if (showStartButton) return;

    if (data.isImageTest) {
      if (!inputValue) {
        setShowNextButton(true);
      }
      setInputValue(value);
    } else {
      if (inputValue.length > 4) return;
      if (inputValue.length > 2) setShowNextButton(true);
      if (inputValue === "") setInputValue(inputValue + value);
      else setInputValue(inputValue + "-" + value);
    }
  };

  const displayResults = () => {
    setDisplayResult(true);
  };

  const ButtonsGroup = () => {
    if (data.isImageTest)
      return (
        <ImageButtons
          combinations={imagesCombinations}
          correctAnswerCombination={correctAnswerCombination}
          onSaveNumberBtnClick={onSaveNumberBtnClick}
        />
      );
    return (
      <NumberButtons
        combinations={combinations}
        onSaveNumberBtnClick={onSaveNumberBtnClick}
      />
    );
  };

  if (loading) return null;

  if (displayResult)
    return (
      <Results
        leftEarResult={leftEarResult}
        result={result}
        updateErrorMessage={props.updateErrorMessage}
        updateSuccessMessage={props.updateSuccessMessage}
      />
    );

  return (
    <S.Container>
      <audio id={"player"} ref={audioElement} preload="none">
        {T.alert}
      </audio>

      <S.GameContainer>
        <S.Column>
          <StartButtons
            showNextButton={showNextButton}
            showStartButton={showStartButton}
            onStartBtnClick={onStartBtnClick}
            onPlayNextBtnClick={onPlayNextBtnClick}
          />

          <Input
            showStartButton={showStartButton}
            inputValue={inputValue}
            onRemoveNumbersBtnClick={onRemoveNumbersBtnClick}
            isImageTest={data.isImageTest}
          />

          {/*{data.isImageTest ? (*/}
          {/*  <>*/}
          {/*    <S.DevText>Õige vastus: {correctAnswerCombination}</S.DevText>*/}
          {/*    <S.DevText>Õige url: {currentUrl}</S.DevText>*/}
          {/*  </>*/}
          {/*) : null}*/}
        </S.Column>

        <S.Column>
          <ButtonsGroup />

          <Button
            id={"backToInstructionsBtn"}
            className={"changeViewBtn"}
            color="secondary"
            size="lg"
            onClick={props.onBackBtnClick}
          >
            {T.back}
          </Button>
        </S.Column>
      </S.GameContainer>
    </S.Container>
  );
};

export default HearingTest;
